export const settingsTabs = {
  // organizationInfo: 'organization-info',
  // companyStructure: 'company-structure',
  userManagement: 'user-management',
  // accountingSettings: 'accounting-settings',
  // notifications: 'notifications',
  // billingSubscription: 'billing-subscription',
  // auditLog: 'audit-log',
  stytchSSO: 'stytch-sso',
} as const;
export type SettingsTab = (typeof settingsTabs)[keyof typeof settingsTabs];
// ^ the values from the object are used for typing the tab

export const settingsURLs = {
  base: '/organization-settings/authentication',
  exchangeRates: '/organization-settings/exchange-rates',

  getTabURL(tab: SettingsTab): string {
    return `/organization-settings/authentication/${tab}`;
  },
};

export const notificationSettingsTabs = {
  periodClose: 'period-close',
  reporting: 'reporting',
  centralDataHub: 'central-data-hub',
} as const;
export type NotificationSettingsTab =
  (typeof notificationSettingsTabs)[keyof typeof notificationSettingsTabs];
